import api from './api';
import type { ProfileUpdateData, AvatarUploadData, ProfileData } from '../types';

class ProfileService {
  /**
   * Get current user profile with stats and documents
   */
  async getProfile(): Promise<ProfileData> {
    const response = await api.get<{
      success: boolean;
      data?: ProfileData;
      error?: string;
    }>('/client/profile');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar perfil');
  }

  /**
   * Update user profile
   */
  async updateProfile(data: ProfileUpdateData): Promise<{ success: boolean }> {
    const response = await api.put<{
      success: boolean;
      message?: string;
      error?: string;
    }>('/client/profile', data);

    if (response.data.success) {
      return { success: true };
    }

    throw new Error(response.data.error || 'Falha ao atualizar perfil');
  }

  /**
   * Upload user avatar
   */
  async uploadAvatar(data: AvatarUploadData): Promise<{ success: boolean }> {
    const response = await api.post<{
      success: boolean;
      message?: string;
      error?: string;
    }>('/client/profile/avatar', {
      avatar: data.base64,
      mimeType: data.mimeType,
    });

    if (response.data.success) {
      return { success: true };
    }

    throw new Error(response.data.error || 'Falha ao atualizar avatar');
  }

  /**
   * Change user password
   */
  async changePassword(senhaAtual: string, novaSenha: string): Promise<{ success: boolean }> {
    const response = await api.put<{
      success: boolean;
      message?: string;
      error?: string;
    }>('/client/profile/password', {
      senhaAtual,
      novaSenha,
    });

    if (response.data.success) {
      return { success: true };
    }

    throw new Error(response.data.error || 'Falha ao alterar senha');
  }

  /**
   * Disable/Deactivate user account
   */
  async disableAccount(): Promise<void> {
    const response = await api.delete<{
      success: boolean;
      error?: string;
    }>('/client/profile');

    if (!response.data.success) {
      throw new Error(response.data.error || 'Falha ao desativar conta');
    }
  }
}

const profileService = new ProfileService();
export default profileService;
